export default __webpack_public_path__ + "static/media/bassanio.7bec9d91.png";